import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { ACCESS_BETA, ACCESS_DISALLOW, ACCESS_SUBSCRIBED, STATUS_BETA, STATUS_RELEASED, SubsData, useSubs } from "../../api/subs/store"
import React, { useEffect, useState } from "react"
import Loading from "../../components/Loading"
import useUXStore from "../../api/ux/store"
import { useUser } from "../../api/users/store"
import { useAuth } from "../../api/auth/store"
import { ADMIN_ROLE, OWNER_ROLE } from "../../constants"

type SubItemProps = {
    data: SubsData
}
const SubItem: React.FC<SubItemProps> = ({data}) => {
    const { updateAccess } = useSubs(state => state)
    const { flagRolesUnloaded } = useUser(state => state)
    const { addToast } = useUXStore(state => state)
    const { hasRole } = useAuth(state => state)
    const [joining,setJoining] = useState(false)
    const isPrivileged = hasRole(OWNER_ROLE) || hasRole(ADMIN_ROLE)
    let btnLabel = ""
    let joined = false
    //console.log(data)
    switch (data.status) {
        case STATUS_BETA:
            btnLabel = "Join beta"
            if (data.accessStatus && data.accessStatus !== ACCESS_DISALLOW) {
                joined = true
                btnLabel = "Cancel"
            }
            break;
        case STATUS_RELEASED: 
            btnLabel = "Subscribe"
            if (data.accessStatus === ACCESS_SUBSCRIBED) {
                joined = true
                btnLabel = "Subscribed"
            }
            break;
    }
    const onJoin = () => {
        let status = ACCESS_BETA
        if (joined) {
            status = ACCESS_DISALLOW            
        }
        setJoining(true)
        updateAccess(status, data.id)
            .then( code => {
                if (code !== "200") return
                if (joined) addToast("", data.name + " beta testing cancelled.")
                else addToast("", "Joined to " +data.name + "!")
                flagRolesUnloaded()
            })
            .finally( () => {
                setJoining(false)
            })
    }
    const onSubscribe = () => {

    }
    const onLaunch = () => {
        window.open(data.link, "_blank")  
    }
    return <Card style={{width:"230px", marginTop:"20px"}}>
        <Card.Img style={{cursor: "pointer"}} src={data.iconl} onClick={onLaunch}/>
        <Card.Body>
            <Card.Title style={{cursor: "pointer"}} onClick={onLaunch}><span>{data.name}</span>
                {data.status === STATUS_BETA && <div style={{display:"inline",color:"#007fff"}}> Beta</div>}
            </Card.Title>
            <Card.Text>
                {data.desc}
            </Card.Text>
            {data.accessStatus !== ACCESS_SUBSCRIBED && data.status === STATUS_BETA && !joining && isPrivileged && <Button size="sm" variant={!joined? "outline-primary":"outline-danger"} 
                onClick={onJoin}>
                {btnLabel}
            </Button>}
            { data.status === STATUS_RELEASED && !joining && isPrivileged && 
                <Button disabled={joined} size="sm" variant="outline-primary" 
                    onClick={onSubscribe}>
                    {btnLabel}
                </Button>}
            {!isPrivileged && joined && <div style={{
                fontSize: "0.75rem", 
                color: "#198754", 
                fontWeight: "700", 
                textTransform: "uppercase",
                backgroundColor: "#e8f5e9",
                padding: "4px 10px",
                borderRadius: "12px",
                display: "inline-block",
                border: "1px solid #c8e6c9"
            }}>
                {data.status === STATUS_BETA ? "Joined Beta" : "Subscribed"}
            </div>}
            {joining && <Loading />}
        </Card.Body>
        
    </Card>
}

const SubsPage = () => {
    const [loading, setLoading] = useState(true)
    const { retrieveSubs, apps } = useSubs(state => state)
    useEffect(() =>{
        setLoading(true)
        retrieveSubs()
        .finally(() => setLoading(false))
    }, [])
    if (loading) return <Loading center/>
    return <Container>
        <Row xs="auto">
        { apps?.map( (val, i) => (
            <Col>
            <SubItem data={val}/>
            </Col> 
        ))}
        </Row>
    </Container>
}

export default SubsPage